module.exports = __webpack_public_path__ + "img/ricette1.resized.9444a31f.jpg";